import PropTypes from 'prop-types';
import React     from 'react';
import style     from './Toggle.module.less';

const Toggle = ({items, onClick}) => {
    let toggleRef;

    const setToggleRef = (ref) => {
        toggleRef = ref;
      };

    const setActiveItemRef = (ref) => {
        if (!ref) return;
        toggleRef.style.width = ref.getBoundingClientRect().width + "px";
        toggleRef.style.left = ref.offsetLeft + "px";
    };

    return <div className={style.toggle}>
        <span className={style.background} ref={setToggleRef}></span>
        <ul className={style.items} role="tablist">
        {items.map((item, idx) => <li key={idx} className={style.item + (item.isActive ? ' ' + style.itemActive : '')} onClick={() => onClick(item)} ref={item.isActive ? setActiveItemRef : null} role="tab" aria-selected={item.isActive} onKeyDown={e => e.key === 'Enter' && onClick(item)} tabindex={0}>{item.text}</li>)}
        </ul>
    </div>;
};

Toggle.propTypes = {
    items: PropTypes.array,
    onClick: PropTypes.func,
};

export default Toggle;
